import styled from 'styled-components';
import Icon from '../../_shared/components/Icon';

export const SearchIconWrapper = styled.div`
  position: absolute;
  left: 66px;
  top: 11px;
`;

export const SearchIcon = styled(Icon).attrs({
  icon: 'TR5-Search_magnify'
})`
  width: 12px;
  height: 12px;
`;

export const SearchInputField = styled.input`
  position: absolute;
  border: none;
  text-indent: 20px;
  z-index: -1;
  left: 60px;
  top: 6px;
  width: 136px;
  height: 32px;
  background: ${({ theme }) => theme.COLORS.NEUTRAL_5};
  border-radius: 3px;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  ::placeholder {
    color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
    text-transform: uppercase;
    font-style: normal;
  }
`;
